module.exports = __webpack_public_path__ + "static/media/815CameronMadisonAlexanderBlvdNW_2018-07-09_139.335e9e27.jpg";